import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_INVESTMENT_TIMELINE } from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";

// import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const getTimelines = createAsyncThunk(
  "getTimelines/GET",
  async ({ cb, failed }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_INVESTMENT_TIMELINE,
      });

      return data;
    } catch (error) {
      failed();
      const msg = proccessErrorMessage(error);
      toast.error(msg);
    }
  }
);
